import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  href = '#pricing',
  className = ''
}: CTAButtonProps) {
  const isAnchor = href.startsWith('#');
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isAnchor) {
      e.preventDefault();
      const el = document.getElementById(href.substring(1));
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <a href={href} onClick={handleClick} target={isAnchor ? undefined : '_blank'} rel={isAnchor ? undefined : 'noopener noreferrer'} className={`block w-full text-center cursor-pointer px-4 py-3 sm:py-4 rounded-lg bg-green text-white font-heading font-extrabold uppercase text-[13px] sm:text-base tracking-wide leading-tight shadow-[0_4px_0_0_#4E6129] hover:bg-green-dark hover:-translate-y-0.5 active:translate-y-0.5 active:shadow-[0_2px_0_0_#4E6129] transition-[transform,background-color,box-shadow] duration-150 ease-out ${className}`} data-id="element-33" data-mp="2p11jbi4ks701">
      {children}
    </a>;
}